import { render, staticRenderFns } from "./ModuleParallel.vue?vue&type=template&id=9c57eb80"
import script from "./ModuleParallel.vue?vue&type=script&lang=js"
export * from "./ModuleParallel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports